<script lang="ts">
    import { Icon } from "sveltestrap";
    import { isDateNowGreater, isInstaceOffline, isUUID, notificationsService } from "../Services";

    export let title: string = '';
    let hasNetwork = true;

    reloadLocalStorage();

        // Escuchar cambios en la conexión de red
    window.addEventListener('online', () => {

        if (localStorage.getItem('hasNetwork') == 'true') return

        if (hasNetwork) return;
        
        hasNetwork = true;

        localStorage.setItem('hasNetwork', hasNetwork.toString());

        notificationsService.notify('Cobertura', 'El dispositivo vuelve a tener cobertura.');
    });

    window.addEventListener('offline', () => {
        hasNetwork = false;
         localStorage.setItem('hasNetwork', hasNetwork.toString());
    });

    // Obtener información sobre la conexión de red actual
    if (!navigator.onLine) {
        hasNetwork = false;
    }


    function reloadLocalStorage(){

        const dateCache = localStorage.getItem('dateCache');
        const currentDate = new Date();

        if (!dateCache) {    
            localStorage.setItem('dateCache', currentDate.toString());
            return;
        }

        if (!isDateNowGreater(dateCache, 2)) {
            return;            
        }
        
        const localStorageArray = Object.entries(localStorage).map(([key, value]) => {
            let parsedValue;
            try {
                parsedValue = JSON.parse(value);
            } catch (error) {
                parsedValue = value;
            }
            return { key, value: parsedValue };
        });

        for (const store of localStorageArray) {
            let deleteStore = true

            if (deleteStore && store.value.rol_id) {
                deleteStore = false
            }

            if (deleteStore && !isUUID(store.key)) {
                deleteStore = false
            }

            if (deleteStore) {
                localStorage.removeItem(store.key);
                localStorage.removeItem(`answer-${store.key}`); 
            }
        }

        localStorage.setItem('dateCache', currentDate.toString());
    }

</script>

<style lang="scss">

    @use '../variables';

    $height: 60px;

    .topbar {
        display: flex;
        justify-content: center;
        align-items: center;
        height: $height;
        background-color: variables.$color-primary;
    }

    .left, .right {
        display: flex;
        justify-content: center;
        align-items: center;
        width: $height;
        height: $height;
    }

    .title {
        width: calc(100% - #{$height * 2});
        color: #fff;
        font-size: 1.2rem;
        text-align: center;
    }

</style>

<div class="topbar">
    <div class="left">
        <slot name="left"></slot>
    </div>
    <div class="title">{title}</div>
    <div class="right">
        <slot name="right"></slot>
    </div>
</div>

{#if !hasNetwork}
    <div>
        <div class="bg-warning text-black px-3 py-2">
            <small><Icon name="exclamation-triangle-fill" /> El dispositivo no tiene cobertura.</small>
        </div>
    </div>
{/if}

